/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StorageService } from '../services/storage.service';
import { environment } from '../../environments/environment';
// import hmacSHA1 from 'crypto-js/hmac-sha1';
// import Base64 from 'crypto-js/enc-base64';
import * as oauth  from 'oauth-sign';

interface Token {
  token_type: string;
  expires_at: number;
  expires_in: number;
  refresh_token: string;
  access_token: string;
  athlete: any;
}
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  redirectUrl: string;
  constructor(private http: HttpClient, private storageService: StorageService) { }

  get isManuallyLoggedIn(): boolean {
    return localStorage.getItem('manualLogIn') !== null;
  }

  get isLoggedIn(): boolean {
    return localStorage.getItem('access_token') !== undefined
      && localStorage.getItem('access_token') !== null
      && !this.hasExpired();
    }

  get needsNewToken(): boolean {
    return localStorage.getItem('access_token') !== undefined
      && localStorage.getItem('access_token') !== null
      && this.hasExpired();
  }

  login(code: string): Observable<Token>{
    const url = 'https://www.strava.com/api/v3/oauth/token'
    + '?client_id='
    + environment.stravaClientId
    + '&client_secret='
    + environment.stravaSecret
    + '&code='+code
    + '&grant_type=authorization_code';
    return this.http.post<Token>(url, {});
  }

  logout() {
    if(localStorage.getItem('access_token')){
      const url = 'https://www.strava.com/oauth/deauthorize'
      + '?access_token=' + localStorage.getItem('access_token');
      this.http.post(url, {}).subscribe(() => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('athlete');
        localStorage.removeItem('allItems');
        localStorage.removeItem('manualLogIn');
        localStorage.removeItem('age');
        localStorage.removeItem('profilePhoto');
        localStorage.removeItem('firstTimeShowing');
        localStorage.removeItem('stats');
        this.storageService.clear();
        },
        ()=>{
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('expires_at');
          localStorage.removeItem('athlete');
          localStorage.removeItem('allItems');
        localStorage.removeItem('manualLogIn');
        localStorage.removeItem('age');
        localStorage.removeItem('profilePhoto');
        localStorage.removeItem('stats');
        localStorage.removeItem('firstTimeShowing');
        this.storageService.clear();
      });
    } else {
      localStorage.removeItem('firstTimeShowing');
      localStorage.removeItem('age');
      localStorage.removeItem('stats');
      localStorage.removeItem('allItems');
        localStorage.removeItem('manualLogIn');
         localStorage.removeItem('profilePhoto');
        this.storageService.clear();
    }
  }

  updateToken(token: Partial<Token>){
    localStorage.setItem('access_token', token.access_token);
    localStorage.setItem('refresh_token', token.refresh_token);
    localStorage.setItem('expires_at', token.expires_at.toString());
  }


  registerUser(token: Token): any {
    localStorage.setItem('access_token', token.access_token);
    localStorage.setItem('refresh_token', token.refresh_token);
    localStorage.setItem('expires_at', token.expires_at.toString());
    localStorage.setItem('athlete',JSON.stringify(token.athlete));
    //athlete: {id: 46107511, username: 'alexchristou', resource_state: 2, firstname: 'Alex', lastname: 'Christou', …}
  }

  hasExpired(): boolean {
    return Math.floor(new Date().getTime()/1000) > +localStorage.getItem('expires_at');
  }

  updateUser(token: Token){
    localStorage.setItem('access_token', token.access_token);
    localStorage.setItem('refresh_token', token.refresh_token);
    localStorage.setItem('expires_at', token.expires_at.toString());
  }

  refreshToken() {
      const url = 'https://www.strava.com/api/v3/oauth/token'
      + '?client_id='
      + environment.stravaClientId
      + '&client_secret='
      + environment.stravaSecret
      + '&refresh_token='+localStorage.getItem('refresh_token')
      + '&grant_type=refresh_token';
      return this.http.post<Token>(url, {});
  }


  garminGetToken(){
    // const nonce = Math.random().toString(36).replace(/[^a-z]/, '').substr(2);
    // const date = Math.floor(new Date().getTime()/1000);
    // const params = {
    //   oauth_consumer_key: environment.garminConsumerKey,
    //   oauth_signature_method:'HMAC-SHA1',
    //   oauth_nonce:nonce,
    //   oauth_timestamp: date,
    //   oauth_version:'1.0',
    // };
    // const body = {};
    // const url ='https://connectapi.garmin.com/oauth-service/oauth/request_token';
    // const baseString = oauth.generateBase('POST',url,params);
    // const path = hmacSHA1(baseString,environment.garminSecret+'&');
    // const headers = new HttpHeaders()
    //   .set('Authorization','OAuth oauth_version="1.0"')
    //   .set('oauth_consumer_key',environment.garminConsumerKey)
    //   .set('oauth_nonce',nonce)
    //   .set('oauth_timestamp',date.toString())
    //   .set('oauth_signature_method','HMAC-SHA1')
    //   .set('oauth_signature',Base64.stringify(path));
    // //console.log(headers);
    // return this.http.post(url,null,{headers});
  }

}
